// extracted by mini-css-extract-plugin
export default {"title":"RedactUserComponent_title__H0TCw","btn_add_ser":"RedactUserComponent_btn_add_ser__H3brs","btn_wrapper":"RedactUserComponent_btn_wrapper__24uv6"};